<script setup lang="ts">
import {services} from "@/config/services";
const {t} = useI18n();
const localePath = useLocalePath();
useSeoMeta({
  title: t("seo.services.title"),
  description: t("seo.services.description"),
  ogTitle: t("seo.services.title"),
  ogDescription: t("seo.services.description"),
  titleTemplate: "%s – Cursus OÜ"
});
</script>
<template>
  <div class="container py-6 lg:py-8">
    <h1 class="font-bold text-3xl lg:text-4xl mb-6">{{ t("label.services") }}</h1>
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-10">
      <nuxt-link v-for="(service, index) in services" :key="index" :to="localePath(`/services/${service.slug}`)"
                 class="relative rounded-xl  overflow-hidden group">
        <nuxt-img :src="`/img/${service.cover}`" format="webp" quality="90"
                  sizes="100vw,sm:50vw,md:75vw,lg:440px,xl:560px"
                  class="overflow-hidden transition-all group-hover:scale-[1.15] duration-500 w-full h-full object-cover"
                  :alt="t(`seo.service-${service.slug}.description`)"/>/>
        <h3 class="absolute bottom-0 left-0 m-4 md:m-6 bg-white/80 backdrop-blur-sm px-3 py-1 rounded-[8px] text-lg">
          {{ t(service.title) }}</h3>
      </nuxt-link>
    </div>
  </div>
</template>